import React from 'react';
import { Line } from 'react-chartjs-2';
import DynamicAttribution from '@/components/shared/DynamicAttribution';

interface ActivityTabProps {
  athleteData: any;
  isDark: boolean;
  generateActivityChart: () => any;
  getChartOptions: (title: string, hasSecondaryAxis?: boolean) => any;
  dataSources?: string[];
}

const ActivityTab: React.FC<ActivityTabProps> = ({ athleteData, isDark, generateActivityChart, getChartOptions, dataSources = ['whoop'] }) => {
  return (
    <div className={`cgm-card rounded-2xl p-8 border ${isDark ? 'border-gray-700/50' : 'border-gray-200/50'} shadow-xl`}>
      <div className="flex flex-col h-96 mb-6">
        <Line
          data={generateActivityChart()}
          options={getChartOptions('Daily Strain & Activity')}
        />
        <DynamicAttribution sources={dataSources} />
      </div>
    </div>
  );
};

export default ActivityTab; 